const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const S3CommandUrl = {
    CreateFolder: `${Backofficebff}/v1/s3/folder`,
    Rename: `${Backofficebff}/v1/s3/rename`,
    Move: `${Backofficebff}/v1/s3/move`,
    Delete: `${Backofficebff}/v1/s3/delete`,
    Upload: `${Backofficebff}/v1/s3/upload`,
};
